import "../../CommonImports";
import "../../Core/core.css";
import "./HeaderCommandBar.css";
import * as Resources from '../../Resources.Page';
export function getFilterItem(onActivate, hasChanges, important) {
    if (important === void 0) { important = true; }
    return {
        ariaLabel: Resources.Filter,
        iconProps: {
            iconName: hasChanges ? "FilterSolid" : "Filter"
        },
        id: "filter",
        important: important,
        onActivate: onActivate,
        subtle: true
    };
}
export function getFullScreenItem(onActivate, fullscreen, important) {
    if (important === void 0) { important = true; }
    return {
        ariaLabel: fullscreen ? Resources.ExitFullScreen : Resources.EnterFullScreen,
        iconProps: {
            iconName: fullscreen ? "BackToWindow" : "FullScreen"
        },
        id: "fullscreen",
        important: important,
        onActivate: onActivate,
        subtle: true
    };
}
export function toggleFullScreen(newFullScreenState) {
    if (newFullScreenState) {
        document.body && document.body.classList.add("full-screen-mode");
    }
    else {
        document.body && document.body.classList.remove("full-screen-mode");
    }
}
